/* eslint-disable no-new */
import Navigation from './modules/Navigation';
import JokeSlider from './modules/JokeSlider';
import JudgmentSlider from './modules/JudgmentSlider';
import DetailsElement from './modules/DetailsElement';
import ScrollButton from './modules/ScrollButton';
import ContactForm from './modules/ContactForm';
import LeafletMap from './modules/LeafletMap';
import 'svgxuse';
import 'mdn-polyfills/Element.prototype.closest';
import 'svg-classlist-polyfill';

new Navigation();
new JokeSlider();
new JudgmentSlider();
new DetailsElement();
new ScrollButton();
new LeafletMap();
new ContactForm();

// eslint-disable-next-line
import style from '../scss/dark-blue.scss';
